import { useTranslation } from 'react-i18next';
import { KoobButton, KoobEmptyState } from '@koob/ui';
import { switchActingOrganization } from '@koob/utils';
import { useApp } from 'hooks';
import KoobLayout from 'components/Koob/KoobLayout';

// KD-3735: for pages that only make sense for one organization (the catalog,
// DMCs, the trip designer…). In the group view ("<group> (Group)") the page
// is replaced by a choice among the group's organizations; picking one
// switches the app's organization picker (and reloads).
const RequireActingOrganization = ({ children }) => {
  const { t } = useTranslation();
  const { user, currentOrganization } = useApp();

  if (!currentOrganization?.isGroup) {
    return children;
  }

  const organizations = (user?.organizations ?? []).filter(
    ({ parentId }) =>
      String(parentId) === String(currentOrganization.organizationId),
  );

  return (
    <KoobLayout>
      <KoobEmptyState
        icon={<i className="fa-light fa-buildings text-2xl" />}
        title={t('misc:organizationRequiredTitle')}
        description={t('misc:organizationRequiredPage')}
      >
        <div className="flex flex-wrap justify-center gap-2">
          {organizations.map(({ organizationId, displayName }) => (
            <KoobButton
              key={organizationId}
              variant="secondary"
              onClick={() => switchActingOrganization(organizationId)}
            >
              {displayName}
            </KoobButton>
          ))}
        </div>
      </KoobEmptyState>
    </KoobLayout>
  );
};

export default RequireActingOrganization;
